import * as React from 'react';
import styles from './index.less';
import { history } from '@@/core/history';
import * as AHooks from 'ahooks';
import { FI18n } from '@freelog/tools-lib';
import fPromiseModalConfirm from '@/components/fPromiseModalConfirm';

interface FPrompt2Props {
  watch: boolean;
  reconfirm?: (location: any) => boolean;
  messageText: string;
  okText?: string;
  cancelText?: string;

  onOk?(locationHref: string): void;

  onCancel?(locationHref: string): void;
}

function FPrompt2({
  watch,
  reconfirm,
  messageText,
  okText,
  cancelText,
  onOk,
  onCancel,
}: FPrompt2Props) {
  const prompting = React.useRef<boolean>(false);

  React.useEffect(() => {
    if (watch) {
      window.onbeforeunload = () => true;
    } else {
      window.onbeforeunload = null;
    }
  }, [watch]);

  React.useEffect(() => {
    if (!watch) return;

    const unblock = history.block((update: any) => {
      const loc = update.location;
      if (prompting.current) return;
      if (reconfirm && !reconfirm(loc)) return;
      prompting.current = true;
      const locationHref: string = loc.pathname + (loc.search || '') + (loc.hash || '');
      handle(locationHref, unblock);
    });

    return () => {
      unblock();
    };
  }, [watch, reconfirm, messageText, okText, cancelText, onOk, onCancel]);

  AHooks.useUnmount(() => {
    window.onbeforeunload = null;
  });

  async function handle(locationHref: string, unblock: () => void) {
    const bool: boolean = await fPromiseModalConfirm({
      title: '提示',
      description: messageText,
      okText: okText || FI18n.i18nNext.tAuto('btn_leave'),
      cancelText: cancelText || FI18n.i18nNext.tAuto('btn_cancel'),
    });

    if (bool) {
      unblock();
      if (onOk) {
        onOk(locationHref);
      } else {
        history.push(locationHref);
      }
    } else {
      if (onCancel) {
        onCancel(locationHref);
      }
    }
    prompting.current = false;
  }

  return null;
}

export default FPrompt2;
